import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { anonymous } from 'routes/config/user'
import AuthRouter from './AuthRouter'

const UserRouter = ({ isAuthenticated, permissions }) => {
  return (
    <Routes>
      {anonymous.map(({ routePath, Component }) => (
        <Route key={routePath} path={routePath} element={<Component />} />
      ))}
      <Route path="/" element={<Navigate to="/signin" replace />} />
      <Route
        path="*"
        element={
          <AuthRouter
            isAuthenticated={isAuthenticated}
            permissions={permissions}
          />
        }
      />
    </Routes>
  )
}

export default UserRouter
